module.exports = __webpack_public_path__ + "static/media/error.c02412f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/error.mp3
// module id = UktP
// module chunks = 0